import ts, { factory, } from "typescript";
import { getProperties } from "../../entity";
var InterfaceGenerator = /** @class */ (function () {
    function InterfaceGenerator(entity) {
        this._imports = [];
        this._entity = entity;
    }
    InterfaceGenerator.prototype.generateDetailComponent = function () {
        var functionalComponent = this.generateInterface();
        return {
            functionDeclaration: functionalComponent,
            imports: this._imports,
        };
    };
    InterfaceGenerator.prototype.generateInterface = function () {
        return factory.createInterfaceDeclaration(undefined, [factory.createModifier(ts.SyntaxKind.ExportKeyword)], factory.createIdentifier(this._entity.getName()), undefined, undefined, this.getInterfaceFields());
    };
    InterfaceGenerator.prototype.getInterfaceFields = function () {
        var _this = this;
        var inputs = getProperties(this._entity).map(function (property) {
            return _this.getPropertySignature(property);
        });
        return inputs;
    };
    InterfaceGenerator.prototype.getPropertySignature = function (property) {
        return factory.createPropertySignature(undefined, factory.createIdentifier(property.getName()), undefined, factory.createKeywordTypeNode(ts.SyntaxKind.StringKeyword));
    };
    return InterfaceGenerator;
}());
export default InterfaceGenerator;
